import React, {Component} from 'react';
import $ from 'jquery';
import UserMenu from './UserMenu';
import util from './lib/util';
let action = {};
let badge = {};

//環境の切り分け
if(document.domain.match(/automation-news.jp/)){
    window.serviceType = 'am-news';
    if(document.domain.match(/www.automation-news.jp/) || document.domain.match(/www.prod.automation-news.jp/) ){
        window.base_domain = '.aperza.com';
        window.tokenKey = 'atkn';
        window.base_cluez_member_domain = 'member.cluez.biz';
        window.cdn_base_domain = '//static.aperza.jp';
        window.env_locale_balloon = null;
    }else if(document.domain.match(/stg.automation-news.jp/)){
        window.base_domain = '.stg.aperza.com';
        window.tokenKey = 'stgatkn';
        window.base_cluez_member_domain = 'member.stg2.cluez.biz';
        window.cdn_base_domain = '//static.stg.aperza.jp';
        window.env_locale_balloon = null;
    }else if(document.domain.match(/test.automation-news.jp/)){
        window.base_domain = '.test.aperza.com';
        window.tokenKey = 'testatkn';
        window.base_cluez_member_domain = 'member.test.cluez.biz';
        window.cdn_base_domain = '//static.test.aperza.jp';
        window.env_locale_balloon = null;
    }else if(document.domain.match(/local.automation-news.jp/)){
        window.base_domain = '.local.aperza.com';
        window.tokenKey = 'localatkn';
        window.base_cluez_member_domain = 'member.test.cluez.biz';
        window.cdn_base_domain = '//static.local.aperza.jp';
        window.env_locale_balloon = null;
    }else if(document.domain.match(/dev.automation-news.jp/)){
        window.base_domain = '.local.aperza.com:8000';
        window.tokenKey = 'atkn';
        window.base_cluez_member_domain = 'member.dev.cluez.biz';
        window.cdn_base_domain = '//static.local.aperza.jp';
        window.env_locale_balloon = null;
    }
}else {
    window.serviceType = 'news-aperza';
    //account, id, ものニュー, サーチ(jp)の本番
    if(location.href.match(/https:\/\/news\.aperza\.jp|https:\/\/aperza\.jp|www\.aperza\.jp|\/\/id\.aperza\.jp|\/\/account\.aperza\.jp|https:\/\/aperza\.com|www\.aperza\.com|\/\/id\.aperza\.com|\/\/account\.aperza\.com|https:\/\/order.aperza\.com|https:\/\/business.aperza\.com/)){
        window.base_domain = '.aperza.com';
        window.base_com_domain = '.aperza.com';
        window.tokenKey = 'atkn';
        window.base_cluez_member_domain = 'member.cluez.biz';
        window.cdn_base_domain = '//static.aperza.jp';
        window.env_locale_balloon = null;
    }else if(document.domain.match(/stg.aperza.jp|stg.aperza.com/)){  //stg
        window.base_domain = '.stg.aperza.com';
        window.base_com_domain = '.stg.aperza.com';
        window.tokenKey = 'stgatkn';
        window.base_cluez_member_domain = 'member.stg2.cluez.biz';
        window.cdn_base_domain = '//static.stg.aperza.jp';
        window.env_locale_balloon = null;
    }else if(document.domain.match(/test.aperza.jp|test.aperza.com/)){ //test
        window.base_domain = '.test.aperza.com';
        window.base_com_domain = '.test.aperza.com';
        window.tokenKey = 'testatkn';
        window.base_cluez_member_domain = 'member.test.cluez.biz';
        window.cdn_base_domain = '//static.test.aperza.jp';
        window.env_locale_balloon = null;
    }else if(document.domain.match(/local.aperza.jp|local.aperza.com/)){ //local
        window.base_domain = '.local.aperza.com';
        window.base_com_domain = '.local.aperza.com';
        window.tokenKey = 'localgtoken';
        window.base_cluez_member_domain = 'member.test.cluez.biz';
        window.cdn_base_domain = '//static.local.aperza.jp';
        window.env_locale_balloon = 'search-local';
    }else{
        window.base_domain = '.test.aperza.com';
        window.base_com_domain = '.test.aperza.com';
        window.tokenKey = 'atkn';
        window.base_cluez_member_domain = 'member.test.cluez.biz';
        window.cdn_base_domain = '//static.test.aperza.jp';
        window.env_locale_balloon = null;
    }

    //サービスの切り替え
    if(document.domain.match(/news/)) {
        window.serviceType = 'news-aperza';
        window.env_locale_balloon = null;
    }else if(document.domain.match(/account/)){
        window.serviceType = 'account-aperza';
        if (document.domain.match(/test/)) {
            window.env_locale_balloon = 'account-test';
        } else if (document.domain.match(/stg/)) {
            window.env_locale_balloon = 'account-stg';
        } else {
            window.env_locale_balloon = null;
        }
    }else if(document.domain.match(/id/)){
        window.serviceType = 'id-aperza';
        if (document.domain.match(/test/)) {
            window.env_locale_balloon = 'id-test';
        } else if (document.domain.match(/stg/)) {
            window.env_locale_balloon = 'id-stg';
        } else {
            window.env_locale_balloon = null;
        }
    }else if(document.domain.match(/order/)) {
        window.serviceType = 'aperza-order';
    } else if (document.domain.match(/business/)) {
        window.serviceType = 'aperza-biz';
    }else {
        window.serviceType = 'search-aperza';
        if (document.domain.match(/test/)) {
            window.env_locale_balloon = 'search-test';
        } else if (document.domain.match(/stg/)) {
            window.env_locale_balloon = 'search-stg';
        } else {
            window.env_locale_balloon = null;
        }
    }
}

//var path = location.href.replace(/^.*\/\/[^\/]+/, '');
var path = (location.pathname + location.search).replace(/^\/+/, '');
if( path !== '/' && window.serviceType != 'aperza-order'){
    window.encodedPath = encodeURIComponent(path);
}

var getCookie = function(key){
  var cookies = document.cookie.split('; ');
  for (var i = 0; i < cookies.length; i++){
    var c = cookies[i].split('=');
      if(c[0] == key){
        return c[1];
      }
  }
  return false;
}

export default class Container extends Component {
    constructor() {
        super();
        this.state = {
          user: {
              userId: 0,
              localId: 0,
              email: '',
              displayName: 'ゲスト',
              photoUrl: 'https://news.aperza.jp/wp-content/themes/aperzamedia/images/img_user.svg',
              regison: '',
              lang: '',
              valid: false
          },
          unreadCount:0,
          isLogin:false,
          isOpen:false,
          isValid:false,
          isBusiness:false
        }
        //test
        window._ = this
        //test
        action.login = () => {
            if(!getCookie(tokenKey)){
              this.setState({isValid:true})
              return false;
            }
            let self = this;
            let url = `https://api${base_domain}/v2/account/validate?withDetail=false&withBuyer=true`;

            if(window.fetch !== undefined) {
                fetch(url, {
                    method: 'GET',
                    headers: {Authorization: getCookie(tokenKey)}
                }).then(
                    response => response.json().then(data => {

                        let approvalFlagBlacklist = [
                          'DATA_INCOMPLETE', 'UNAPPLIED',
                        ];

                        if( data.valid ) {
                            let user = data;
                            user.photoUrl = user.photoUrl || 'https://static.aperza.jp/component/user_menu/images/img_user.svg'
                            let bizFlag = (approvalFlagBlacklist.indexOf(user.buyer.approvalFlag) == -1) ? true : false;
                            self.setState({
                                user: user,
                                isLogin: true,
                                isBusiness: bizFlag,
                            })
                            util.batchClip();
                            self.setState({isValid:true});
                            badge.refresh();
                        }
                    }))
                .catch(function(error) {
                    self.setState({isValid:true});
                });
            } else {
                // For IE11
                let xhr = new XMLHttpRequest();

                xhr.onreadystatechange = function() {
                    if( this.readyState == 4 && this.status == 200 ) {
                        if( this.response ) {
                            let data = JSON.parse(this.response);
                            if ( data.valid ) {
                                let user = data;
                                user.photoUrl = user.photoUrl || 'https://static.aperza.jp/component/user_menu/images/img_user.svg';
                                self.setState({
                                    user: user,
                                    isLogin: true
                                });
                                util.batchClip();
                                self.setState({isValid:true});
                                badge.refresh();
                            }
                        }
                    }
                }

                xhr.open('GET', url, true);
                xhr.setRequestHeader('Authorization', getCookie(tokenKey));
                xhr.responseType = 'json';
                xhr.send(null);
            }
        }

        action.checkEnv = ()=>{
        }
        //test
        action._dummyLogin = () => {
            this.setState({
              user: {
                  userId: 1,
                  localId: 1,
                  email: 'dummy@aperza.biz',
                  displayName: '山田アペルザ',
                  photoUrl: 'https://news.aperza.jp/wp-content/themes/aperzamedia/images/img_user_dummy.jpg',
                  regison: 'JP',
                  lang: 'ja',
                  valid: true
              }
            });
        }
        //test

        action.openMenu = ()=>{
          this.setState({isOpen:true});
        }

        action.closeMenu = ()=>{
          this.setState({isOpen:false});
        }
        action.badge = ()=>{
          this.interval = setInterval(badge.refresh, 60000);
        }
        badge.refresh = () =>{
          if(!getCookie(tokenKey)){
            return false;
          }
          let self = this;
          let url = `https://api${base_domain}/v2/information/unreadcount?lang=${this.state.user.lang}&region=${this.state.user.region}`;

        if(window.fetch !== undefined) {
            fetch(url,{
                method: 'GET',
                headers: {Authorization: getCookie(tokenKey)}
            })
                .then(
                    response => response.json().then(data => {
                        if(data && data.data && data.data.total_count) {
                            self.setState({unreadCount: data.data.total_count});
                        }
                    })    
                )
                .catch(function(error) {});
        } else {
            // For IE11
            let xhr = new XMLHttpRequest();

            xhr.onreadystatechange = function() {
                if( this.readyState == 4 && this.status == 200 ) {
                    if( this.response ) {
                        let data = JSON.parse(this.response);
                        if( data.data && data.data.total_count ) {
                            self.setState({
                                unreadCount: data.data.total_count
                            });
                        }
                    }
                }
            }
            xhr.open('GET', url, true);
            xhr.setRequestHeader('Authorization', getCookie(tokenKey));
            xhr.responseType = 'json';
            xhr.send(null);
        }

        }

    }

    componentDidMount() {
      action.checkEnv();
        action.login();
        action.badge();
        window.__user_menu = {};
        window.__user_menu.state = this.state;
        window.__user_menu.action = action;
        window.__user_menu.this = this;
    }

    render() {
        return (<UserMenu action={action} state={this.state}/>);
    }
}



// WEBPACK FOOTER //
// ./src/UserMenuContainer.js